(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('.hmenu__item.is-open').forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var btn = item.querySelector('.hmenu__toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function updateTrack(track) {
      var list = track.querySelector('.hmenu__list');
      if (!list) return;
      var max = list.scrollWidth - list.clientWidth;
      track.classList.toggle('can-scroll-prev', list.scrollLeft > 4);
      track.classList.toggle('can-scroll-next', max > 4 && list.scrollLeft < max - 4);
    }

    function initTracks(root) {
      (root || document).querySelectorAll('.hmenu__track').forEach(function (track) {
        var list = track.querySelector('.hmenu__list');
        if (!list || track.dataset.hmenuInit) {
          updateTrack(track);
          return;
        }
        track.dataset.hmenuInit = 'true';
        list.addEventListener('scroll', function () {
          track.classList.add('has-scrolled');
          updateTrack(track);
        }, { passive: true });
        updateTrack(track);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initTracks(); });
    } else {
      initTracks();
    }
    window.addEventListener('load', function () { initTracks(); });
    window.addEventListener('resize', function () { initTracks(); });
    document.addEventListener('shopify:section:load', function (event) { initTracks(event.target); });

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('.hmenu__arrow');
      if (arrow) {
        var list = arrow.closest('.hmenu__track').querySelector('.hmenu__list');
        var dir = arrow.classList.contains('hmenu__arrow--prev') ? -1 : 1;
        list.scrollBy({ left: dir * list.clientWidth * 0.7, behavior: 'smooth' });
        return;
      }

      if (event.target.closest('.hmenu__dropdown')) return;

      var toggle = event.target.closest('.hmenu__toggle');
      if (!toggle) {
        closeAll(null);
        return;
      }

      var item = toggle.closest('.hmenu__item');
      closeAll(item);
      var isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('.hmenu__item.is-open');
      if (!open) return;
      closeAll(null);
      var btn = open.querySelector('.hmenu__toggle');
      if (btn) btn.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-countdown-sale"] && !Shopify.designMode) return;
  try {
    
  class KsCountdown extends HTMLElement {
    constructor () {
      super()

      if (!this.dataset.time.length) {
        this.innerHTML = 'Datetime is missing!'
      }

      let countDownDate = Number(this.dataset.time) * 1000

      if (window.location.href.includes('ks-')) {
        countDownDate = Date.now() + 1.728e+8
      }

      const x = setInterval(() => {
        const now = new Date().getTime()
        const distance = countDownDate - now

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        const sec = Math.floor((distance % (1000 * 60)) / 1000)

        if (days > 0) {
          this.querySelector('[data-days]').innerHTML = `${days} <em>${this.dataset.textDays}</em>`
        } else {
          this.querySelector('[data-days]')?.remove()
        }
        if (hours > 0) {
          this.querySelector('[data-hours]').innerHTML = `${hours} <em>${this.dataset.textHours}</em>`
        } else {
          this.querySelector('[data-hours]')?.remove()
        }
        this.querySelector('[data-min]').innerHTML = `${min} <em>${this.dataset.textMin}</em>`
        this.querySelector('[data-sec]').innerHTML = `${sec} <em>${this.dataset.textSec}</em>`

        this.setAttribute('data-init', '')

        if (distance < 0) {
          clearInterval(x)
          this.innerHTML = this.dataset.textExpired
        }
      }, 1000)
    }
  }
  customElements.define('ks-countdown', KsCountdown)


  } catch(e) { console.error(e); }
})();
})();
